import { useMutation } from '@tanstack/react-query';
import { edupassClient } from '../@clients';

interface changePasswordParams {
  currentPassword: string;
  newPassword: string;
}

export const useChangePassword = () => {
  return useMutation({
    mutationFn: async ({
      currentPassword,
      newPassword,
    }: changePasswordParams) => {
      await edupassClient.post('/alterar_senha', {
        senha: currentPassword,
        novaSenha: newPassword,
      });
    },
  });
};
